import MockupPhoneTellYourStory from './MockupPhoneTellYourStory';

export default MockupPhoneTellYourStory;
